var React = require('react');

function IconCheckboxChecked (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"16","rx":"2","fill":"#1E7CB3","key":0}),React.createElement("path",{"d":"M6.17794 10.5747L3.80728 7.98335L3 8.85956L6.17794 12.3333L13 4.87621L12.1984 4L6.17794 10.5747Z","fill":"white","key":1})]);
}

IconCheckboxChecked.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconCheckboxChecked;

IconCheckboxChecked.default = IconCheckboxChecked;
